import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import { CURRENCY } from '../libs/utils/Const';
//formato de cantidades 
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
if (isNaN(num)) {
    return num;
}
return this.formatear(Number(num).toFixed(2));
}
}

const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body: "";

    body = data.map((register, index) => {

       


        if (register.statusBorrador != 'W' && register.statusBorrador != 'Y') {
            return (
                <tr key={index}>
                    <td className="sticky-column">
                        <input type="checkbox" style={{minWidth: '100%'}} id="cbox2"
                               checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)}/>
                    </td>
                    {headers[0].value && <td>{register.ItemCode}</td>}
                    {headers[1].value && <td>{register.ItemName}</td>}
                    {headers[2].value && <td>{Number.parseFloat(register.OnHand).toFixed(4)}</td>}

                    <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                                onClick={() => openDetails({ItemCode: register.ItemCode, index})}
                                style={{fontWeight: '500'}}>
                            <i className="far fa-file-alt">
                            </i> Ver Detalles
                        </button>
                    </td>
                </tr>
            )
        }
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";
    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-column" style={{backgroundColor: "#e9ecef"}}>
                <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" value="second_checkbox"
                       onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{width: '100%'}}>
        <thead className="table-header">
        {header}
        </thead>
        <tbody>
        {body}
        </tbody>
    </table>;

    return table;

};

export const renderInventoryData = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}
